import React, { createContext, useContext, useState, useEffect } from 'react';

const PopupContext = createContext();

export const PopupProvider = ({ children }) => {
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [hasSeenPopup, setHasSeenPopup] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem('hasSeenPopup')) {
      setIsPopupVisible(true);
      sessionStorage.setItem('hasSeenPopup', 'true');
      setHasSeenPopup(true);
    }
  }, []);

  const openPopup = () => setIsPopupVisible(true);
  const closePopup = () => setIsPopupVisible(false);

  return (
    <PopupContext.Provider value={{ isPopupVisible, openPopup, closePopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = () => useContext(PopupContext);